import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import CKEditor from "react-ckeditor-component";
import { useDispatch, useSelector } from "react-redux";
import {
  addNote,
  getSingleNote,
  getSubadminList,
  updateNote,
} from "../../../../store/actions";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loading from "../../../../Common/extra/loading";
import { MenuItem, Select } from "@material-ui/core";

const AddEditNoteIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editId, noteId } = useParams();
  const [loading, setLoading] = useState(false);
  const admin_id = localStorage && localStorage.getItem("id");
  const UserList = useSelector((s) => s?.Signatures?.subadmins?.data);
  const [state, setState] = useState({
    id: "",
    receiver_id: "",
    sender_id: "",
    note_content: "",
    sender_type: "admin",
    type: "sent",
    status: "1",
    title: "",
    assign_to: [],
  });
  const noteData = useSelector((s) => s?.Customers?.singleNote?.data);

  useEffect(() => {
    dispatch(getSubadminList());
  }, [dispatch]);

  useEffect(() => {
    if (noteData && editId && noteId) {
      setState((pre) => ({
        ...pre,
        note_content: noteData?.note_content,
        id: noteData?.id,
        assign_to:
          noteData?.assign_to &&
          noteData?.assign_to.length > 0 &&
          noteData?.assign_to.map((itm) => itm.id),
        title: noteData?.title,
      }));
    }
  }, [noteData, editId, noteId]);

  const [backUrl, setBackUrl] = useState(`/customers/notes/${editId}`);

  useEffect(() => {
    if (editId && admin_id) {
      setState((pre) => ({ ...pre, receiver_id: editId, sender_id: admin_id }));
      dispatch(getSingleNote(noteId));
    }
  }, [editId, admin_id]);

  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setState((prevState) => ({
      ...prevState,
      note_content: newContent,
    }));
  };

  const handleSubmit = (e, type) => {
    e.preventDefault();
    setLoading(true);

    const callback = (res) => {
      setLoading(false);
      if (res.data) {
        toast.success("Added Successfully");
        if (type == "exit") {
          navigate(`/customers/profile/${editId}`);
        }
      } else {
      }
    };

    const updateCallBack = (res) => {
      setLoading(false);
      if (res.data) {
        toast.success("Updated Successfully");
        if (type == "exit") {
          navigate(`/customers/profile/${editId}`);
        }
      } else {
      }
    };

    if (noteData) {
      dispatch(
        updateNote(
          {
            ...state,
            assign_to: JSON.stringify(state.assign_to),
            receiver_type: "user",
          },
          updateCallBack
        )
      );
    } else {
      dispatch(
        addNote(
          { ...state, assign_to: JSON.stringify(state.assign_to) },
          callback
        )
      );
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setState((pre) => ({ ...pre, [name]: value }));
  };

  return (
    <>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="bg-white px-4 py-3 card-box rounded">
                <Form>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Note Title
                      </label>
                      <input
                        type="text"
                        name="title"
                        value={state?.title}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Assign Note to the Team
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        multiple
                        name="assign_to"
                        value={state.assign_to}
                        onChange={handleChange}
                        MenuProps={UserList}
                      >
                        {UserList &&
                          UserList.length > 0 &&
                          UserList.map((item, idx) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name + " " + item.last_name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </Col>
                    <Col lg="12" className="my-2">
                      <label for="" className="form-label2 m-0">
                        Write Note
                      </label>
                      {loading && <Loading className={"cstmLoader"} />}
                      <CKEditor
                        activeClass="p10"
                        content={state.note_content}
                        events={{
                          change: onChange,
                          disabled: true,
                        }}
                      />
                    </Col>
                  </Row>
                </Form>
                <div className="d-flex subscribe-back">
                  <Button
                    onClick={(e) => handleSubmit(e, "save")}
                    className="d-flex align-items-center justify-content-center me-1"
                    disabled={
                      state.note_content == "" ||
                      state.assign_to.length == 0 ||
                      state.title == ""
                        ? true
                        : false
                    }
                  >
                    Save
                  </Button>
                  <Button
                    onClick={(e) => handleSubmit(e, "exit")}
                    className="d-flex align-items-center justify-content-center"
                    disabled={state.note_content == "" ? true : false}
                  >
                    Save & Exit
                  </Button>
                  <Link
                    className="d-flex btn-2 border align-items-center justify-content-center me-2"
                    to={backUrl}
                  >
                    Back
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddEditNoteIndex;
